import Globalize from '@sprinx/globalize';
import forLocale from '../utils/forLocale';
var localeFmt = {};
/**
 * Vrati naformatovane procento.
 *
 * @function
 * @param {number | string} [num] Cislo k formatovani.
 * @returns {string}
 */

var percentFormatter = function percentFormatter(num) {
  return forLocale(localeFmt, function (fmt) {
    /* istanbul ignore next */
    if (!fmt) {
      fmt = Globalize.numberFormatter({
        style: 'percent',
        round: 'round'
      });
    }

    var toFormat = typeof num === 'string' ? Number.parseFloat(num) : num;
    return typeof toFormat !== 'number' || Number.isNaN(toFormat) ? '' : fmt(toFormat);
  });
};

export default percentFormatter;